import * as React from 'react';
import { RouteObject, Navigate } from 'react-router-dom';

const About = React.lazy(() => import(/* webpackChunkName: "public-about" */ '../../containers/Unauthenticated/About'));
const Error = React.lazy(() => import(/* webpackChunkName: "public-error" */ '../../containers/Unauthenticated/Error'));
const Login = React.lazy(() => import(/* webpackChunkName: "public-login" */ '../../containers/Unauthenticated/Login'));
const LoginClient = React.lazy(
    () => import(/* webpackChunkName: "public-login-client" */ '../../containers/Unauthenticated/Login/children/Client')
);
const LoginInfo = React.lazy(() => import(/* webpackChunkName: "login-info-alert" */ '../../components/LoginInfo'));
const LoginAdmin = React.lazy(
    () => import(/* webpackChunkName: "public-login-admin" */ '../../containers/Unauthenticated/Login/children/Admin')
);
const LoginLandingPage = React.lazy(
    () =>
        import(/* webpackChunkName: "public-login-landing" */ '../../containers/Unauthenticated/Login/children/Landing')
);
const Logout = React.lazy(
    () => import(/* webpackChunkName: "public-logout" */ '../../containers/Unauthenticated/Logout')
);
const Register = React.lazy(
    () => import(/* webpackChunkName: "public-register" */ '../../containers/Unauthenticated/Register')
);

export const UnauthenticatedRoutes: RouteObject[] = [
    {
        index: true,
        element: <Navigate to="/login" />
    },
    {
        path: 'about',
        element: (
            <React.Suspense fallback={<>...</>}>
                <About />
            </React.Suspense>
        )
    },
    {
        path: 'error/:errorCode',
        element: (
            <React.Suspense fallback={<>...</>}>
                <Error />
            </React.Suspense>
        )
    },
    {
        path: 'login',
        element: (
            <React.Suspense fallback={<>...</>}>
                <Login />
            </React.Suspense>
        ),
        children: [
            {
                index: true,
                element: (
                    <React.Suspense fallback={<>...</>}>
                        <LoginClient />
                    </React.Suspense>
                )
            },
            {
                path: 'admin',
                element: (
                    <React.Suspense fallback={<>...</>}>
                        <LoginAdmin />
                    </React.Suspense>
                )
            },
            {
                path: 'landing',
                element: (
                    <React.Suspense fallback={<>...</>}>
                        <LoginLandingPage />
                    </React.Suspense>
                )
            },
            {
                path: 'info/:errorType',
                element: (
                    <React.Suspense fallback={<>...</>}>
                        <LoginInfo />
                        <LoginClient />
                    </React.Suspense>
                )
            }
        ]
    },
    {
        path: 'logout',
        element: (
            <React.Suspense fallback={<>...</>}>
                <Logout />
            </React.Suspense>
        )
    },
    {
        path: 'register',
        element: (
            <React.Suspense fallback={<>...</>}>
                <Register />
            </React.Suspense>
        )
    }
];
